<div class="question-panel">
  <div class="question-panel__header">
    <div class="question-panel__title">
      {{headerTitle}}
    </div>
    <div class="question-panel__number">
      <p><span [ngClass]="totalAmount > percentAmount ? 'is-invalid' : ''">{{totalAmount | number}}</span> of {{percentAmount}} %</p>
    </div>
  </div>

  <div class="custom-answer__group custom-answer__group--percent form-group mb-0" data-linked-add="custom-answer-add-1">
    @for (activity of activities; track activity) {
      <div class="custom-answer" [ngClass]="allowDelete ? 'has-delete' :''">
        <div class="custom-answer__title">
          <input type="text" [(ngModel)]="activity.value" [placeholder]="placeHolderText" class="form-control"
            [ngClass]="activity.valueInvalid ? 'is-invalid' : ''" (ngModelChange)="onModelChange(activity, 'value')">
          </div>
          <div class="custom-answer__percent">
            <input type="number" [(ngModel)]="activity.percent" placeholder="0" class="form-control"
              [ngClass]="activity.percentInvalid ? 'is-invalid' : ''" (ngModelChange)="onModelChange(activity, 'percent')">
              <span class="custom-answer__percent-indi">%</span>
            </div>
            @if (allowDelete) {
              <div class="custom-answer__delete">
                <a class="action-remove" (click)="deleteActivity(activity)">
                  <svg class="icon"><use xlink:href="#trash"></use></svg>
                </a>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <aside class="question-add">
      <button class="button-control" id="custom-answer-add-1" (click)="addAnotherActivity()">
        <svg class="icon"><use xlink:href="#plus-filled"></use></svg><strong>Add Another Activity</strong>
      </button>
    </aside>
